/* eslint semi:0 */
import cookie from 'cookie'
import { registerUtils, } from 'application/nm';
import { create as makeEmptyObj, } from 'utils/object'

let allCookies = cookie.parse(document.cookie)
let epoch = new Date('Thu, 01 Jan 1970 00:00:01 GMT')

let cookies = Object.assign(makeEmptyObj(), {

  get: function getCookie(name) {
    return allCookies[name]
  },

  set: function setCookie(name, value, options = {}) {
    document.cookie = cookie.serialize(name, value, options);
    allCookies = cookie.parse(document.cookie)
  },

  expire: function(name) {
    document.cookie = cookie.serialize(name, '', { expires: epoch });
    allCookies = cookie.parse(document.cookie)
  },

})

registerUtils({ cookies, });

export default cookies


// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/utils/cookies.js